import useTranslate from 'hooks/useTranslate';
import { MuiChipsInput, MuiChipsInputChip } from 'mui-chips-input';
import { Col, Form, Row } from 'react-bootstrap';
import ActionMenu from '../ActionMenu';
import useResumeStore from 'store/resume';

const Hobbies = ({
	data,
	slug,
	handleRemoveClick,
	handleModalVisibility,
	handleTitleChange,
	checkLimitExceed,
	stateResumeForm,
	setStateResumeForm,
}: any) => {
	const resumeData = useResumeStore((state) => state?.resumeData);
	const { translate } = useTranslate();

	const fieldVisibility = useResumeStore(
		(state) => state?.resumeData?.manageTemplateFields?.[slug] || false,
	);

	const handleChange = (newValue: MuiChipsInputChip[]) => {
		setStateResumeForm({
			...stateResumeForm,
			[slug]: newValue,
		});
	};

	return (
		<div className="hobbies resume-info">
			<Form>
				<div className="build-resume-edit-header">
					<ActionMenu
						data={data}
						handleRemoveClick={handleRemoveClick}
						slug="hobbiesTitle"
						contentSlug={slug}
						handleModalVisibility={handleModalVisibility}
						handleTitleChange={handleTitleChange}
					/>
					<p className="mb-0">{translate('Resume.hobbiesSubtitle')}</p>
				</div>
				{fieldVisibility && (
					<div className="build-resume-edit-fields">
						<Row>
							<Col xl="12">
								<div className="mb-3 text-start chip-input">
									<MuiChipsInput
										value={resumeData?.[slug]}
										onChange={handleChange}
										size="medium"
										hideClearAll
										className="w-100"
										label={translate('PlaceHolder.enterHobbies')}
										variant="filled"
										InputProps={{ readOnly: checkLimitExceed(slug) ? false : true }}
										placeholder={translate('PlaceHolder.typeAndPressEnter')}
									/>
								</div>
							</Col>
						</Row>
					</div>
				)}
			</Form>
		</div>
	);
};

export default Hobbies;
